import useEventGenericV2 from './use-event-generic'

export default (eventParams = []) =>
  eventParams.map(eventParam => useEventGenericV2({
    eventParam,
    isInitialiser: true
  }))
